<template>
  <div class="input-group">
    <slot />
  </div>
</template>

<style lang="scss">
@import '@libero/ui-framework/InputGroup/InputGroup.scss';
</style>
